import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Box, Stack, Typography} from '@mui/material';
import {useRef} from 'react';
import axios from 'axios';
import {useSelector} from 'react-redux';
import {constance} from "../../common/constance/constance";
import {RootState} from "../../reducer";
import {common} from "../../common/common";
const sha256 = require('sha256');

export default function ChangePasswordDialog(state: any, setState: any) {
    console.log('[ChangePasswordDialog]');

    const handleClose = () => {
        setState({
            ...state,
            openChangePassword: false,
        });
    };

    let inputRef: any = useRef();
    let inputNewPW1: any = useRef();
    let inputNewPW2: any = useRef();
    let messageRef: any = useRef();

    let contentRef: any = useRef();
    const commonData = useSelector((state: RootState) => state.commonData);

    function handleChangePassword() {
        let oldPw = inputRef.current.value;
        let newPw1 = inputNewPW1.current.value;
        let newPw2 = inputNewPW2.current.value;

        if (oldPw == '') {
            messageRef.current.innerText = '* 현재 비밀번호를 입력해주세요'
            return;
        }

        if (newPw1 !== newPw2) {
            messageRef.current.innerText = '* 새로 입력한 비밀번호가 일치하지 않습니다.'
            return;
        }

        if (newPw1.length < 8) {
            messageRef.current.innerText = '* 8자리 이상 입력하여 주세요'
            return;
        }

        if (newPw1.search(/\s/) !== -1) {
            messageRef.current.innerText = '* 공백 없이 입력해주세요'
            return;
        }

        // 패스워드 유효성검사
        var num = newPw1.search(/[0-9]/g);
        var eng = newPw1.search(/[a-z]/ig);
        var spe = newPw1.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi);
        if (num < 0 || eng < 0 || spe < 0) {
            messageRef.current.innerText = '* 영문, 숫자, 특수문자를 혼합하여 입력해주세요.'
            return;
        }


        let params: any = {
            id: commonData.user.id,
            oldPw: sha256(oldPw),
            newPw: sha256(newPw1),
        };
        axios.post(constance.api.changePassword, {
            ...params,
        }).then(value => {
            if (value.data.result) {
                common.alert('', '비밀번호가 성공적으로 변경되었습니다.', 'info');
            } else {
                common.alert('', '비밀번호 변경 실패', 'info');
            }
            setState({
                ...state,
                openChangePassword: false
            });
        }).catch(reason => {
            common.alert('', '비밀번호 변경 실패', 'info');
        }).finally(() => {
            inputRef.current.value = '';
        });
    }


    return (
        <div>
            <Dialog open={state.openChangePassword} onClose={handleClose} sx={{maxHeight: '100vh'}}>
                <DialogTitle>
                    <Box sx={{display: 'flex'}}>
                        <Typography variant={'h5'}>
                            {`비밀번호 변경`}
                        </Typography>
                    </Box>
                </DialogTitle>
                <DialogContent ref={contentRef}>
                    <DialogContentText>
                        <Stack sx={{width: {xs: 250, sm: 300, md: 400}}}>
                            <Box sx={{mt: 2}}>
                                <TextField
                                    inputRef={inputRef}
                                    autoFocus
                                    margin="dense"
                                    label="현재 비밀번호를 입력해주세요."
                                    type="password"
                                    fullWidth
                                    variant="standard"
                                />
                            </Box>


                            <Box sx={{mt: 1}}>
                                <TextField
                                    inputRef={inputNewPW1}
                                    margin="dense"
                                    label="새로운 비밀번호를 입력해주세요."
                                    type="password"
                                    fullWidth
                                    variant="standard"
                                />
                            </Box>
                            <Box sx={{mt: 1}}>
                                <TextField
                                    inputRef={inputNewPW2}
                                    margin="dense"
                                    label="새로운 비밀번호를 다시 입력해주세요."
                                    type="password"
                                    fullWidth
                                    variant="standard"
                                />
                            </Box>
                            <Stack sx={{display: 'flex', alignItems: 'flex-start', mt: 1, color: '#c01515'}}>
                                <Typography ref={messageRef}
                                            variant={'subtitle2'}>
                                    {`* 8자리 이상 입력하여 주세요.`}
                                </Typography>
                                <Typography ref={messageRef}
                                            variant={'subtitle2'}>
                                    {`* 영문, 숫자, 특수문자를 혼합하여 입력해주세요.`}
                                </Typography>
                            </Stack>
                            <Box sx={{display: 'flex', justifyContent: 'center', mt: 1}}>
                                <Typography ref={messageRef}
                                            color={'red'}
                                            variant={'subtitle1'}>
                                    {` `}
                                </Typography>
                            </Box>
                        </Stack>
                    </DialogContentText>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>닫기</Button>
                    <Button onClick={handleChangePassword}>등록</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}